import { Minus, Plus } from '@phosphor-icons/react'
import { Button } from '@/shared/components/ui/button'

export function HorizonGuestStepper({
  label,
  value,
  min = 1,
  max,
  decrementLabel,
  incrementLabel,
  onChange,
}: {
  label: string
  value: number
  min?: number
  max?: number
  decrementLabel: string
  incrementLabel: string
  onChange: (value: number) => void
}) {
  const canDecrement = value > min
  const canIncrement = max === undefined || value < max

  return (
    <div className="flex items-center justify-between gap-4 rounded-[var(--brand-radius-lg)] border border-[var(--brand-border)] bg-[var(--brand-surface)] p-3">
      <span className="text-sm font-medium text-[var(--brand-text-primary)]">{label}</span>
      <div className="flex items-center gap-3">
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="size-10 rounded-pill"
          disabled={!canDecrement}
          aria-label={decrementLabel}
          onClick={() => onChange(value - 1)}
        >
          <Minus className="size-4" aria-hidden />
        </Button>
        <span className="min-w-6 text-center text-sm font-semibold tabular-nums text-[var(--brand-text-primary)]">
          {value}
        </span>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="size-10 rounded-pill"
          disabled={!canIncrement}
          aria-label={incrementLabel}
          onClick={() => onChange(value + 1)}
        >
          <Plus className="size-4" aria-hidden />
        </Button>
      </div>
    </div>
  )
}
